import CategoriaDeCurriculo, {
  FinderCategoriasDeCurriculo,
  RetornoCategoriaDeCurriculo,
} from 'Interface/CategoriasDeCurriculo';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'CategoriasDeCurriculo';

const url = '/categorias-de-curriculo';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarCategoriasDeCurriculo: construtor.query<
        FinderCategoriasDeCurriculo,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.categorias
            ? [
                ...resultado.categorias.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarCategoriaDeCurriculo: construtor.query<
        RetornoCategoriaDeCurriculo,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarCategoriaDeCurriculo: construtor.mutation<
        CategoriaDeCurriculo,
        Partial<CategoriaDeCurriculo>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarCategoriaDeCurriculo: construtor.mutation<
        CategoriaDeCurriculo,
        Partial<CategoriaDeCurriculo> &
          Pick<CategoriaDeCurriculo, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerCategoriaDeCurriculo: construtor.mutation<
        CategoriaDeCurriculo,
        Partial<CategoriaDeCurriculo> & Pick<CategoriaDeCurriculo, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarCategoriasDeCurriculoQuery,
  useRecuperarCategoriaDeCurriculoQuery,
  useAdicionarCategoriaDeCurriculoMutation,
  useEditarCategoriaDeCurriculoMutation,
  useRemoverCategoriaDeCurriculoMutation,
} = apiExtendida;
